import {useNavigate} from "react-router-dom";
import React from "react";
import styled from "styled-components";
import {useAuth0} from "@auth0/auth0-react";
import {PostApi} from "../../../Api/AuthenticatedApi";
import {Button, Input, Modal, Typography} from "@arco-design/web-react";

const {Text} = Typography;

// MUI Dialog(+Title/Content/Actions) -> Arco Modal (visible/onCancel/title/
// footer). Paper -> styled div; List/ListItem/ListItemText -> styled divs;
// TextField -> Input (onChange passes value, not an event); ButtonGroup ->
// Button.Group; Typography(textSecondary) -> Text type="secondary".
const Paper = styled.div`
    overflow: auto;
    max-height: 400px;
    background: var(--color-bg-2);
`;

const SuggestionItem = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 16px;
`;


export function SuggestionsDialog({data, render, dataSetter, marketingType}) {
    const [open, setOpen] = React.useState(false);
    const defaultName = data && data.name;
    const [contentDescription, setContentDescription] = React.useState("");
    const [emailTopic, setEmailTopic] = React.useState("");
    const [name, setName] = React.useState(defaultName);
    const [loading, setLoading] = React.useState(false);
    const [suggestions, setSuggestions] = React.useState([]);
    const {getAccessTokenSilently} = useAuth0();
    let history = useNavigate();


    const getNewSuggestionFactory = (marketingType) => {
        return (event) => {
            setLoading(true);

            (async () => {
                let url = "/api/generate-copy/"
                PostApi(getAccessTokenSilently, url,
                    (data) => {
                        setLoading(false);
                        setSuggestions([data.response, ...suggestions]);
                    },
                    (response) => {
                        setLoading(false);
                        history("/login");
                    }, (response) => {
                        setLoading(false);
                        console.error("Failed to load data", response);
                    },
                    {
                        attributes: contentDescription.split(","),
                        subject: emailTopic,
                        type: marketingType
                    }
                )
            })();
        }
    }


    const handleClickOpen = () => {
        setOpen(true);
        setName(defaultName);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleClear = () => {
        setSuggestions([]);
    };

    return (
        <>
            {render(handleClickOpen)}
            <Modal
                visible={open}
                onCancel={handleClose}
                title="AI Copy Generator"
                footer={
                    <Button.Group>
                        <Button onClick={getNewSuggestionFactory(marketingType)} type="primary"
                                disabled={!!!emailTopic}>
                            Generate Content
                        </Button>
                        <Button onClick={handleClear} type="primary" disabled={suggestions.length === 0}>
                            Clear
                        </Button>
                        <Button onClick={handleClose} type="text">
                            Close
                        </Button>
                    </Button.Group>
                }
            >
                <>
                    <Paper>

                        {
                            suggestions.length > 0 || (
                                <Text type="secondary">
                                    Generate some suggestions
                                </Text>
                            )
                        }

                        {
                            suggestions.length > 0 && (
                                <div>
                                    {
                                        suggestions.map((suggestion) => (
                                            <SuggestionItem key={`id-${suggestion}`}>
                                                <span>{suggestion}</span>
                                                <Button type="text" onClick={(e) => {
                                                    dataSetter(suggestion);
                                                    handleClose();
                                                }} value={suggestion}>Use</Button>
                                            </SuggestionItem>
                                        ))
                                    }
                                </div>
                            )
                        }
                    </Paper>

                    <div style={{marginTop: 16, marginBottom: 4}}>Email Topic</div>
                    <Input
                        autoFocus
                        value={emailTopic}
                        onChange={(value) => {
                            setEmailTopic(value);
                        }}
                    />

                    <div style={{marginTop: 16, marginBottom: 4}}>Add any descriptions here</div>
                    <Input
                        value={contentDescription}
                        onChange={(value) => {
                            setContentDescription(value);
                        }}
                    />

                </>
            </Modal>
        </>
    );
}
